import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteFileMutationVariables = Types.Exact<{
  data: Types.DeleteFileInput;
}>;


export type DeleteFileMutation = { deleteFile?: { success?: boolean | null } | null };


export const DeleteFileDocument = /*#__PURE__*/ gql`
    mutation DeleteFile($data: DeleteFileInput!) {
  deleteFile(data: $data) {
    success
  }
}
    `;

export function useDeleteFileMutation() {
  return Urql.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument);
};